import { h1 } from "@/styles/typography";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

const StepsContainer = styled.section`
  width: 100%;
  background-color: #f5f5f5;
`;

const S = {
    StepsContainer
};

export default S;
